import { useEffect, useState } from "react";
import { RenderAnimationProps, Router } from "easy-page-router/react";

import News from "./pages/News";
import New from "./pages/New";
import Mayors from "./pages/Mayors";
import AboutUs from "./pages/AboutUs";
import Page from "./pages/Page";
import Downloads from "./pages/Downloads";
import Projects from "./pages/Projects";
import Project from "./pages/Project";
import Contact from "./pages/Contact";
import NotFound from "./pages/NotFound";

export default function TSORouter() {
    return (
        <Router
            renderAnimation={Animation}
            renderPage={({ path }) => {
                // aktuality
                if (path.length === 0) return <News />;

                if (path[0] === "aktualita" && path[1]) return <New id={path[1]} />;

                if (path[0] === "o-nas" && path[1] === "kontakty") return <Contact />;
                if (path[0] === "o-nas" && path[1]) return <Page url={path[1]} />;
                if (path[0] === "o-nas") return <AboutUs />;

                if (path[0] === "uredni-deska") return <Downloads
                    title="Úřední deska"
                    folder="board"
                    background="papers"
                />;
                if (path[0] === "verejne-dokumenty") return <Downloads
                    title="Veřejné dokumenty"
                    folder="documents"
                    background="writer"
                />;

                if (path[0] === "projekt" && path[1]) return <Project url={path[1]} />;
                if (path[0] === "projekty") return <Projects />;

                if (path[0] === "starosta") return <Mayors />;

                return <NotFound />;
            }}
        />
    );
}

function Animation({ page, state }: RenderAnimationProps) {
    const [newClass, setNewClass] = useState("new");
    const [hide, setHide] = useState(false);

    useEffect(() => {
        if (state === "active") {
            setHide(false);
        } else {
            setNewClass("");
            setTimeout(() => setHide(true), 500);
        }
    }, [state]);

    return <div className={`page-animation ${state} ${newClass} ${hide ? "hidden" : ""}`}>{page}</div>;
}
